import { api } from '@app/config/axios';
import { UserRoles } from '@features/access-control/dto/permissions';

export type LoginPostParams = {
  cpf: string;
  password: string;
};

export type LoginResponse = {
  token: string;
} & VerifyCodeResponse;

export type VerifyCodeResponse = {
  access_token: string;
  userInfo: {
    role: UserRoles;
    id: string;
  };
};

export async function loginService(params: LoginPostParams) {
  const response = await api.post<LoginResponse>('/auth', params);
  return response.data;
}

export async function verifyCodeService(code: string) {
  const response = await api.post<VerifyCodeResponse>(
    '/auth/verify/validate-code',
    { code },
  );

  return response.data;
}

export async function verifyByEmail(token: string) {
  await api.post('/auth/verify/email', { token });
}
